import { GoogleMap, Marker, MarkerClusterer } from "@react-google-maps/api";
import React, { useEffect, useRef, useState } from "react";
import { useDispatch, useSelector } from "react-redux";
import Getcurrentlocation from "./Getcurrentlocation";
import { getAddress } from "../../request/Fetchcurrentaddress";
import { Postrequestcall } from "../../request/Postrequest";
import { FETCH_SITES, SITE_DETAIL_TYPE, SITE_ISSUES } from "../../constant/Apipath";
import unnamed from "../../assets/images/unnamed.png";
import mapMarkerYellow from "../../assets/images/marker_yellow.png";
import mapMarkerBlue from "../../assets/images/marker_blue.png";
import Loader from "../../common/Loader";
import { Badge, Box, Card, Menu, MenuItem, Tooltip, tooltipClasses } from "@mui/material";
import Sitetypes from "../sites/Sitetypes";
import SearchMap from "../sites/SearchMap";
import TuneIcon from "@mui/icons-material/Tune";
import { IconButton, Stack } from "@mui/material";
import NearMeIcon from "@mui/icons-material/NearMe";
import AddIcon from "@mui/icons-material/Add";
import Selectoption from "../sites/Selectoption";
import Addsite from "../sites/Addsite";
import {
  setNolocationcount,
  setSelectedProjectdata,
  setSelectedsite,
  setSelectedSiteId,
  setSelectlocation,
  setShowReport
} from "../../redux/actions/actions";
import SiteCard from "../sites/SiteCard";
import styled from "@emotion/styled";
import { BIBlue, mapStyle } from "../../assets/helpers";
import { useTheme } from "@mui/material/styles";
import FilterNoneIcon from "@mui/icons-material/FilterNone";
import { Getrequestcall } from "../../request/Getrequest";
import { English } from "../../constant/EnglishFallback";
import { ClusterSiteListModal } from "./ClusterSiteListModal";
import Pages from "../../constant/ReportModel";
import AddProjectFromMap from "./AddProjectFromMap";

const clusterOptions = {
  styles: [
    {
      textColor: "#000000",
      textSize: 13,
      height: 56,
      width: 56,
      url: "https://unpkg.com/@googlemaps/markerclustererplus@1.0.3/images/m2.png"
    }
  ]
};

const createCircleIcon = (color, radius) => ({
  path: window.google.maps.SymbolPath.CIRCLE,
  fillColor: color,
  fillOpacity: 0.7,
  strokeColor: BIBlue,
  strokeOpacity: 20,
  strokeWeight: 30,
  scale: radius
});

const MapScreen = (props) => {
  const {
    loginData,
    showMapmodal,
    multiLanguageData,
    selectedSiteId,
    noLocationcount,
    reportSuccess,
    reportData,
    showAddexperience,
    selectedProject
  } = useSelector((state) => state?.main);

  const mapRef = useRef(null);
  const markerSiteMapRef = useRef(new Map()); // Map to store marker -> site data

  const [location, setLocation] = useState({ lat: 51.0447331, lng: -114.0718831 });
  const [chooseLocation, setChooseLocation] = useState({ lat: 51.0447331, lng: -114.0718831 });
  const [currentLocation, setCurrentlocation] = useState({ lat: 51.0447331, lng: -114.0718831 });
  const [siteList, setSiteList] = useState([]);
  const [map, setMap] = useState(null);
  const [loading, setLoading] = useState(true); // Loader state
  const [activeTab, setActiveTab] = useState("");
  const [showOption, setShowoption] = useState(false);
  const [filterFlag, setFilterFlag] = useState(false);
  const [searchTerm, setSearchTerm] = useState("");
  const [showAddsite, setShowaddsite] = useState(false);
  const [siteAddressData, setSiteAddressData] = useState({});
  const [showSiteCardModal, setShowSiteCardModal] = useState(false);
  const [showDropMarkerOnMap, setShowDropMarkerOnMap] = useState(false);
  const [showSitedetail, setShowsitedetail] = useState(false);
  const [siteTypes, setSitetypes] = useState(false);
  const [mapTypeId, setMapTypeId] = useState(0);
  const [selectedMapType, setSelectedMapType] = useState("default");
  const [moreMenuAnchorEl, setMoreMenuAnchorEl] = useState(false);
  const [selectSite, setSelectSite] = useState(0);
  const [showAddProjectFromMap, setShowAddProjectFromMap] = useState(false);

  const theme = useTheme();
  const [clusterSiteList, setClusterSiteList] = useState([]);
  const [viewClusterSiteModal, setViewClusterSiteModal] = useState(false);
  const dispatch = useDispatch();

  const validValues = [
    "experience",
    "earn-rewards",
    "company-detail",
    "product-detail",
    "manufacture-detail"
  ];

  const {
    TEXT_SEARCH_BAR = English?.Map?.TEXT_SEARCH_BAR,
    MODAL_TYPE_SELECT_DEFAULT = English?.Map?.MODAL_TYPE_SELECT_DEFAULT,
    MODAL_TYPE_SELECT_HYBRID = English?.Map?.MODAL_TYPE_SELECT_HYBRID,
    MODAL_TYPE_SELECT_SATELLITE = English?.Map?.MODAL_TYPE_SELECT_SATELLITE,
    MODAL_TYPE_SELECT_TERRAIN = English?.Map?.MODAL_TYPE_SELECT_TERRAIN,
    TEXT_ALL_FILTER = English?.Map?.TEXT_ALL_FILTER
  } = multiLanguageData?.Map || {};

  const mapTypes = [
    { id: 0, label: "Default", translateLable: MODAL_TYPE_SELECT_DEFAULT },
    { id: 1, label: "Hybrid", translateLable: MODAL_TYPE_SELECT_HYBRID },
    { id: 2, label: "Satellite", translateLable: MODAL_TYPE_SELECT_SATELLITE },
    { id: 3, label: "Terrain", translateLable: MODAL_TYPE_SELECT_TERRAIN }
  ];

  useEffect(() => {
    const preventZoom = (e) => {
      if (e.ctrlKey) {
        e.preventDefault();
      }
    };
    if (loading) {
      window.addEventListener("wheel", preventZoom, { passive: false });
    }
    return () => {
      window.removeEventListener("wheel", preventZoom);
    };
  }, [loading]);

  // Note :: If we report any site we need to refresh the map again bez when we report any site It will be hide from the site list
  useEffect(() => {
    if (map !== null) {
      getSiteData().then(() => {
        if (props?.locationState?.siteId || props?.locationState?.id) {
          onSiteClick(props?.locationState);
        }
      });
    }
    return () => {
      setSelectSite(0);
    };
  }, [map]);

  const getSiteData = async () => {
    setShowSiteCardModal(false);
    await Promise.all([await getLocation(), await getNolocationsites()]);
  };

  useEffect(() => {
    if (reportSuccess !== true) {
      if (reportData?.AppScreenId === Pages?.site?.id) {
        let reportObj = {
          showReport: false,
          recordId: 0,
          name: "",
          AppScreenId: 0
        };
        dispatch(setShowReport(reportObj));
        getSiteData();
      }
    }
  }, [reportSuccess]);

  // When we add experience from  Select Option --> Add Project we need to show Site detail

  useEffect(() => {
    if (showAddexperience === false && selectedProject?.from === "select-option") {
      dispatch(setSelectedProjectdata(null));
      setShowAddProjectFromMap(false);
      setShowDropMarkerOnMap(false);
      setSitetypes(false);
      setFilterFlag(false);
      setShowsitedetail(true);
      setShowSiteCardModal(true);
    }
  }, [showAddexperience]);

  const getLocation = async () => {
    try {
      let getValue = await Getcurrentlocation();
      setCurrentlocation({
        lat: getValue?.lat,
        lng: getValue?.lng
      });
      if (showMapmodal?.from === "dashboard") {
        getLocationForDashboard();
      } else {
        setLocation({
          lat: getValue?.lat,
          lng: getValue?.lng
        });
        setChooseLocation({
          lat: getValue?.lat,
          lng: getValue?.lng
        });
        await getSitesofCurrentlocation(getValue?.lat, getValue?.lng, activeTab);
      }
    } catch (error) {
      console.error("getLocation-> Error fetching location:", error);
    }
  };

  const getNolocationsites = async () => {
    try {
      const getResponse = await Getrequestcall(
        SITE_ISSUES + `/${loginData?.userInformation?.UserId}`,
        loginData?.accessToken
      );
      if (getResponse.status === 200) {
        dispatch(setNolocationcount(getResponse.data?.data?.length)); // Showing red icon for no location
      } else {
        dispatch(setNolocationcount(0));
      }
    } catch (error) {
      dispatch(setNolocationcount(0));
    }
  };

  const getLocationForDashboard = async () => {
    try {
      const payload = { SearchList: [{ Id: selectedSiteId }] };
      const siteResponseData = await Postrequestcall(FETCH_SITES, payload, loginData?.accessToken);
      if (siteResponseData.status === 200) {
        let siteResponse = siteResponseData?.data?.data[0] ?? {};
        setLocation({
          lat: siteResponse?.latitude,
          lng: siteResponse?.longitude
        });
        setChooseLocation({
          lat: siteResponse?.latitude,
          lng: siteResponse?.longitude
        });
        await getSitesofCurrentlocation(siteResponse?.latitude, siteResponse?.longitude, activeTab);
        dispatch(setSelectedsite(siteResponseData?.data?.data[0]));
        setSelectSite(siteResponseData?.data?.data[0]?.id);
        setShowsitedetail(true);
        setShowSiteCardModal(true);
      }
    } catch (error) {
      console.log("getLocationForDashboard-> Error When getting Location For Dashboard: ", error);
    }
  };

  const onFilterClick = async (value) => {
    setActiveTab(value);
    await getSitesofCurrentlocation(location?.lat, location?.lng, value);
  };

  const getTabFilterType = (tab) => {
    switch (tab) {
      case "Active Sites":
        return 0;
      case "My Sites":
        return 1;
      case "Following":
        return 2;
      case "Unnamed":
        return 3;
      default:
        return 0;
    }
  };

  const getSitesofCurrentlocation = async (lat, lng, tab) => {
    try {
      let addressData = await getAddress({ lat, lng });
      let addressObj = addressData.objAddress;
      let bounds = map?.getBounds();
      const payload = {
        Active: tab === "Active Sites" ? 1 : 0,
        latitude: addressObj.lat,
        longitude: addressObj.lng,
        VP_Latitude_NE: bounds?.getNorthEast()?.lat(),
        VP_Latitude_SW: bounds?.getSouthWest()?.lat(),
        VP_Longitude_NE: bounds?.getNorthEast()?.lng(),
        VP_Longitude_SW: bounds?.getSouthWest()?.lng(),
        UserId: loginData?.userInformation?.UserId,
        Filters: getTabFilterType(tab),
        FetchAllowedRecordsOnly: true
      };
      setLoading(true); // Show loader just before API call
      const response = await Postrequestcall(SITE_DETAIL_TYPE, payload, loginData?.accessToken);
      if (response.status === 200) {
        const siteResponse = response.data?.data;
        if (showMapmodal?.from === "dashboard") {
          const filteredSites = siteResponse.filter((site) => site.id === selectedSiteId);
          setSiteList(filteredSites);
        } else {
          setSiteList(siteResponse ?? []);
        }
        setLoading(false); // Hide loader after API call completes
      }
    } catch (error) {
      console.error("getSitesofCurrentlocation-> Error fetching Site Details By Type: ", error);
    } finally {
    }
  };

  const handleMapInteraction = async () => {
    if (!mapRef.current) return;
    const mapInstance = mapRef.current;
    const bounds = mapInstance.getBounds();
    if (!bounds) {
      console.warn("handleMapInteraction-> Map bounds not available yet, skipping API call.");
      return;
    }
    const center = mapInstance.getCenter();
    const lat = center.lat();
    const lng = center.lng();
    setLocation({ lat, lng });
    await getSitesofCurrentlocation(lat, lng, activeTab, "1");
  };

  // Debounce wrapper:
  const debounceRef = useRef(null);

  const handleMapInteractionDebounced = () => {
    // Clear previous timer if exists
    if (debounceRef.current) clearTimeout(debounceRef.current);

    // Set new timer
    debounceRef.current = setTimeout(() => {
      handleMapInteraction();
    }, 800);
  };

  const handleMapClick = async (e) => {
    const { lat, lng } = e.latLng.toJSON();
    setChooseLocation({ lat, lng });
    // If filter flag true then close the filter
    setFilterFlag(false);
    setSitetypes(false);
    try {
      // When we need to add project not to show choose site here we are checking showMapmodal?.select === "project"
      if (showMapmodal?.select === "site" || showMapmodal?.from === "dashboard") {
        const addressData = await getAddress({ lat, lng });
        setSiteAddressData(addressData?.objAddress);
      } else {
        const addressData = await getAddress({ lat, lng });
        setSiteAddressData(addressData?.objAddress);
        setShowDropMarkerOnMap(true);
        setShowsitedetail(false);
        dispatch(setSelectedsite(null));
        setSelectSite(null);
        setShowSiteCardModal(true);
      }
    } catch (error) {
      console.error("handleMapClick-> Error When Fetching Clicked Map Location Address: ", error);
    }
  };

  const handleNearLocation = async () => {
    try {
      const currentLocation = await Getcurrentlocation();
      const { lat, lng } = currentLocation;
      if (mapRef.current) {
        // Center and zoom the map to the user's current location
        mapRef.current.panTo({ lat, lng });
        mapRef.current.setZoom(15); // Adjust the zoom level as needed
      }
      setLocation({ lat, lng }); // Update state for location and drop marker
      setChooseLocation({ lat, lng });
      setCurrentlocation({ lat, lng });
    } catch (error) {
      console.error("handleNearLocation-> Error When Getting Current Location: ", error);
    }
  };

  const handleSearch = async (place) => {
    let lat = Number(place.geometry.location.lat());
    let lng = Number(place.geometry.location.lng());
    setLocation({ lat, lng });
    await getSitesofCurrentlocation(lat, lng, activeTab);
  };

  const handleFilterFlag = () => {
    setActiveTab("");
    setFilterFlag(true);
  };

  const onSiteClick = async (site) => {
    if (props.modal === true) {
      if (validValues.includes(showMapmodal?.from)) {
        if (showMapmodal?.select === "project") {
          setShowsitedetail(true);
        } else if (showMapmodal?.select === "site") {
          setShowsitedetail(false);
        } else {
          setShowsitedetail(true);
        }
      } else if (showMapmodal?.from === "dashboard") {
        setShowsitedetail(true);
      } else {
        setShowsitedetail(false);
      }
    } else {
      setShowsitedetail(true);
    }
    dispatch(setSelectedsite(site)); // When site showing in map on pag
    setSelectSite(site?.id);
    setShowDropMarkerOnMap(false);
    setSitetypes(false);
    setShowSiteCardModal(true);
    setFilterFlag(false); // If filter flag true then close the filter
  };

  const selectOption = () => {
    setSelectSite(null);
    dispatch(setSelectedsite(null));
    setShowoption(true);
  };

  const LightTooltip = styled(({ className, ...props }) => (
    <Tooltip className="LightTooltip1" {...props} classes={{ popper: className }} />
  ))(() => ({
    [`& .${tooltipClasses.tooltip}`]: {
      backgroundColor: "white",
      color: "rgba(0, 0, 0, 0.87)",
      boxShadow: "0 1px 2px rgba(60, 64, 67, 0.3), 0 2px 6px 2px rgba(60, 64, 67, 0.15)",
      bottom: 5,
      fontSize: 15
    }
  }));

  return (
    <Box className={props?.modal !== true && "main-content-Box"}>
      <GoogleMap
        mapContainerStyle={{
          height:
            props?.modal === true
              ? "82vh"
              : `calc(100vh - ${theme?.mixins?.toolbar?.minHeight || 0}px)`,
          position: "relative"
        }}
        center={location}
        mapContainerClassName="main-map"
        zoom={16}
        onLoad={(mapInstance) => {
          mapRef.current = mapInstance;
          setMap(mapInstance);
          mapInstance.setOptions({
            restriction: {
              latLngBounds: {
                north: 85,
                south: -85,
                east: 180,
                west: -180
              },
              strictBounds: true
            },
            styles: mapStyle
          });
        }}
        options={{
          fullscreenControl: false,
          streetViewControl: false,
          mapTypeControlOptions: false,
          keyboardShortcuts: false,
          disableDefaultUI: true,
          clickableIcons: false,
          zoomControl: false,
          mapTypeControl: false,
          minZoom: 3
        }}
        mapTypeId={
          mapTypeId == 0
            ? "roadmap"
            : mapTypeId == 1
              ? "hybrid"
              : mapTypeId == 2
                ? "satellite"
                : mapTypeId == 3
                  ? "terrain"
                  : ""
        }
        onDragEnd={handleMapInteractionDebounced}
        onZoomChanged={handleMapInteractionDebounced}
        onClick={handleMapClick}>
        {loading ? (
          <Loader fullScreen={true} />
        ) : (
          <>
            <MarkerClusterer
              clusterClass="map-culster"
              options={clusterOptions}
              onClick={(cluster) => {
                const markers = cluster.getMarkers();
                if (markers.length > 1) {
                  const currentZoom = mapRef.current.getZoom();
                  const maxZoom =
                    mapRef.current.mapTypes.get(mapRef.current.getMapTypeId()).maxZoom || 21;

                  // Get all sites from the marker map
                  const clusterSites = markers
                    .map((marker) => markerSiteMapRef.current.get(marker))
                    .filter(Boolean)
                    // Remove duplicates by site ID
                    .filter(
                      (site, index, self) => self.findIndex((s) => s.id === site.id) === index
                    );
                  // Check if cluster is at a zoom level where it won't expand further
                  const isNearMaxZoom = currentZoom >= maxZoom - 2;
                  // Show modal if we have sites and cluster is at max zoom
                  if (clusterSites.length >= 1 && isNearMaxZoom) {
                    setClusterSiteList(clusterSites);
                    setViewClusterSiteModal(true);
                  }
                  // If cluster is not near max zoom, let default behavior handle expansion
                }
              }}>
              {(clusterer) =>
                siteList.map((site) => {
                  return (
                    <Marker
                      key={site.id}
                      onClick={() => onSiteClick(site)}
                      position={{ lat: site.latitude, lng: site.longitude }}
                      clusterer={clusterer}
                      title={`site-${site.id}`}
                      onLoad={(marker) => {
                        // Store site data in map when marker loads
                        markerSiteMapRef.current.set(marker, site);
                      }}
                      icon={{
                        url:
                          activeTab === "FollowSites" || activeTab === "WorkedSites"
                            ? mapMarkerBlue
                            : activeTab === "UnnamedSites"
                              ? unnamed
                              : site.isMySites
                                ? mapMarkerBlue
                                : site.name === ""
                                  ? unnamed
                                  : mapMarkerYellow,
                        scaledSize:
                          selectSite === site.id
                            ? new window.google.maps.Size(35, 45)
                            : new window.google.maps.Size(25, 35)
                      }}
                    />
                  );
                })
              }
            </MarkerClusterer>
            <Marker
              position={{
                lat: currentLocation?.lat,
                lng: currentLocation?.lng
              }}
              icon={createCircleIcon("#4285F4", 4)}
            />
            {showDropMarkerOnMap && (
              <Marker
                position={chooseLocation}
                icon={{
                  url: mapMarkerBlue,
                  scaledSize: new window.google.maps.Size(35, 40)
                }}
              />
            )}
          </>
        )}
        {showMapmodal?.from !== "dashboard" && (
          <>
            {validValues.includes(showMapmodal?.from) && showMapmodal?.select === "site" ? (
              <></>
            ) : (
              <>
                <IconButton
                  className="none-icon"
                  color="primary"
                  onClick={(event) => {
                    setMoreMenuAnchorEl(event.currentTarget);
                  }}>
                  <FilterNoneIcon sx={{ fontSize: "25px" }} />
                </IconButton>
                <Stack className="mapicon-group">
                  <IconButton
                    className="mapicon-btn locationicon-btn"
                    color="primary"
                    onClick={handleNearLocation}>
                    <NearMeIcon sx={{ fontSize: "28px" }} />
                  </IconButton>
                  <IconButton
                    className="mapicon-btn plusicon-btn"
                    color="primary"
                    onClick={() => selectOption()}>
                    <AddIcon sx={{ fontSize: "28px" }} />
                  </IconButton>
                </Stack>
              </>
            )}
            <Card
              className={"searchText-Box-Container"}
              sx={{ borderRadius: "25px", border: "1px solid #e3e3e3" }}>
              <SearchMap
                setSearchTerm={setSearchTerm}
                searchTerm={searchTerm}
                handleSearch={handleSearch}
                from={"map"}
                placeholder={TEXT_SEARCH_BAR}
              />
            </Card>

            <Menu
              anchorEl={moreMenuAnchorEl}
              open={Boolean(moreMenuAnchorEl)}
              onClose={(event) => {
                setMoreMenuAnchorEl(false);
              }}>
              {mapTypes.map((mapType) => (
                <MenuItem
                  key={mapType.id}
                  onClick={() => {
                    setMapTypeId(mapType.id);
                    setSelectedMapType(mapType.label.toLowerCase());
                    setMoreMenuAnchorEl(null);
                  }}
                  style={{
                    backgroundColor:
                      selectedMapType === mapType.label.toLowerCase() ? "#083DB8" : "inherit",
                    color: selectedMapType === mapType.label.toLowerCase() ? "#fff" : "#083DB8"
                  }}>
                  {mapType.translateLable}
                </MenuItem>
              ))}
            </Menu>

            {!loginData?.sourceDataFrom && !filterFlag && (
              <Box className="allfilter-Btn">
                <LightTooltip title={TEXT_ALL_FILTER}>
                  <IconButton className="all-filter-icon" onClick={handleFilterFlag}>
                    <Badge
                      color="error"
                      variant="dot"
                      invisible={
                        typeof noLocationcount === "undefined"
                          ? true
                          : noLocationcount > 0
                            ? false
                            : true
                      }>
                      <TuneIcon />
                    </Badge>
                  </IconButton>
                </LightTooltip>
              </Box>
            )}
          </>
        )}

        {/* Site detail  */}
        {showSiteCardModal && (
          <SiteCard
            setShowaddsite={setShowaddsite}
            showSitedetail={showSitedetail}
            siteTypes={siteTypes}
            showDropMarkerOnMap={showDropMarkerOnMap}
            siteAddressData={siteAddressData}
            chooseLocation={chooseLocation}
            showSiteCardModal={showSiteCardModal}
            from={props?.modal ? "modal" : "page"}
            setShowSiteCardModal={setShowSiteCardModal}
            setShowsitedetail={setShowsitedetail}
            onClose={() => {
              setShowSiteCardModal(false);
              setShowDropMarkerOnMap(false);
              dispatch(setSelectedsite(null));
              setSelectSite(null);
            }}
            onFilterClick={onFilterClick}
            filterFlag={filterFlag}
            getSitesofCurrentlocation={getSitesofCurrentlocation}
            setShowDropMarkerOnMap={setShowDropMarkerOnMap}
            getNolocationsites={getNolocationsites}
            activeTab={activeTab}
          />
        )}

        {filterFlag && (
          <Sitetypes
            handleSearch={handleSearch}
            setSearchTerm={setSearchTerm}
            searchTerm={searchTerm}
            filterFlag={filterFlag}
            setFilterFlag={setFilterFlag}
            onFilterClick={onFilterClick}
            location={location}
            siteList={siteList}
            setShowsitedetail={setShowsitedetail}
            loading={loading}
            showSiteCardModal={showSiteCardModal}
            setShowSiteCardModal={setShowSiteCardModal}
            onClose={() => {
              setFilterFlag(false);
              onFilterClick("");
              setSearchTerm("");
              setShowSiteCardModal(false);
            }}
            setSitetypes={setSitetypes}
            activeTab={activeTab}
            from={props?.modal ? "modal" : "page"}
          />
        )}

        {/* Select Option  */}
        {showOption && (
          <Selectoption
            showNavigation={props.showNavigation}
            setShowaddsite={setShowaddsite}
            showOption={showOption}
            setShowoption={setShowoption}
            setChooseLocation={setChooseLocation}
            from={props?.modal ? "modal" : "page"}
            currentLocation={currentLocation}
            setShowAddProjectFromMap={setShowAddProjectFromMap}
          />
        )}

        {/* Add site  */}
        {showAddsite && (
          <Addsite
            location={location}
            handleClose={() => {
              setShowaddsite(false);
              setShowoption(false);
              setShowSiteCardModal(false);
              setShowDropMarkerOnMap(false);
              let closeMapModal = {
                open: false,
                from: "",
                lat: 0,
                lng: 0
              };
              dispatch(setSelectlocation(closeMapModal));
              dispatch(setSelectedsite(null));
              setSelectSite(null);
              dispatch(setSelectedSiteId(0));
              dispatch(setSelectedProjectdata(null));
            }}
            showAddsite={showAddsite}
            getSitesofCurrentlocation={getSitesofCurrentlocation}
            showDropMarkerOnMap={showDropMarkerOnMap}
            filterFlag={filterFlag}
            activeTab={activeTab}
          />
        )}

        {viewClusterSiteModal && (
          <ClusterSiteListModal
            open={viewClusterSiteModal}
            onClose={() => setViewClusterSiteModal(false)}
            clusterSiteList={clusterSiteList || []}
            onSiteClick={onSiteClick}
          />
        )}

        {/* Add Project From Map Modal */}
        {showAddProjectFromMap && (
          <AddProjectFromMap
            open={showAddProjectFromMap}
            onClose={() => setShowAddProjectFromMap(false)}
            onSuccess={() => {
              setShowAddProjectFromMap(false);
              setShowDropMarkerOnMap(false);
              setSitetypes(false);
              setFilterFlag(false);
              setShowsitedetail(true);
              setShowSiteCardModal(true);
            }}
          />
        )}
      </GoogleMap>
    </Box>
  );
};

export default MapScreen;
